// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option-active{border:1px solid #1976d2;width:100%;cursor:pointer}.option-deactive{border:1px solid #dfdfdf;width:100%;cursor:pointer}", ""]);
// Exports
module.exports = exports;
